/**
 * Route for `enterprise-plan`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EnterprisePlanPage } from "../features/enterprise-plan/EnterprisePlanPage";

export const enterprisePlanRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/enterprise-plan",
	component: EnterprisePlanPage,
});

export default enterprisePlanRoute;
